import { FC, useEffect } from 'react';
import '../styles/LoadingAnim.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import userImage from '../../../assets/images/defaultAvatar.png';
import { FiPlus } from 'react-icons/fi';
import { Button } from '../../../components/Button';
import store from '../../../store/store';
import { addBreadcrumb } from '../../../components/Breadcrumbs/reducer/breadcrumbSlice';

const AddBrandLink: FC<{}> = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const breadcrumbHandle = () => {
    // const data: any = [
    //   {
    //     label: 'Users',
    //     link: `/users`,
    //   },
    //   {
    //     label: 'Add new user',
    //     link: ``,
    //   },
    // ];
    // // const data: any = {};
    // store.dispatch(addBreadcrumb(data));
    navigate(`/offers/add-new-offer`);
  };

  return (
    <div className="pb-0 mt-0 hidden">
      {/* <div className="flex items-center justify-center"></div> */}
      {/* <div className="flex gap-4"> */}
        <Button
          className="flex justify-center w-full items-center text-semi lg:text-base lg:h-auto font-medium gap-2 py-2 top-[140px] tracking-[0.025em] no-underline  lg:px-5 bg-primary3 rounded hover:no-underline visited:text-purple-700 right-2 hover:shadow-hoverShadow md:text-base max-lg:px-4"
          onClick={breadcrumbHandle}
          iconBefore={<FiPlus className="text-white font-semibold" size={18} />}
        >
          Add Offer
        </Button>
      </div>
    // </div>
  );
};

export default AddBrandLink;
